module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": ("Which " + _vm.integration_name + "  courses do you want to import to Parlay?"),
      "size": 'xl',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('body', {
    staticClass: "px-7 pt-7 pb-4 flex-grow overflow-y-auto"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "col-xs-10 sub-header"
  }, [_vm._v("\n        Import courses will automatically create accounts for teachers and\n        students in those courses (if the account don’t already exist), and\n        roster the courses accordingly.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.loading_update_data) ? _c('pl-spinner', {
    staticClass: "x1",
    staticStyle: {
      "margin": "auto"
    }
  }) : _c('pl-button', {
    staticClass: "w-100 pl-primary-font b",
    staticStyle: {
      "margin": "0",
      "border-bottom": "2px solid #d9d9d9",
      "border-right": "2px solid #d9d9d9"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.edlinkSchoolIntegrationCourses.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-redo mr2"
  }), _vm._v("\n          Update Data\n        ")])], 1)]), _vm._v(" "), (_vm.courses) ? _c('div', {
    staticClass: "mt3 ph3"
  }, [_c('admin-portal-integrations-filters-bar', {
    staticClass: "mb-3",
    attrs: {
      "coursesFilters": _vm.coursesFilters
    },
    on: {
      "filters": _vm.filters,
      "admin-portal-filter-changed": _vm.resetFilters
    }
  }), _vm._v(" "), (_vm.courses.length) ? _c('table', {
    staticClass: "courses-table w-100"
  }, [_c('thead', [_c('tr', {
    staticClass: "row no-margin middle-xs"
  }, [_c('td', {
    staticClass: "col-xs-1",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('pl-checkbox', {
    staticClass: "col-xs-1",
    on: {
      "change": function($event) {
        return _vm.handleSelectAll($event)
      }
    },
    model: {
      value: (_vm.allSelected),
      callback: function($$v) {
        _vm.allSelected = $$v
      },
      expression: "allSelected"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "col-xs-3"
  }, [_vm._v("Course & Section")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v("Teacher")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v("Co-Teachers")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1"
  }, [_vm._v("Subject")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1"
  }, [_vm._v("School / Site")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1"
  }, [_vm._v("Grade")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1"
  }, [_vm._v("Students")])])]), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "integrations-course-modal"
    },
    on: {
      "scroll": function($event) {
        return _vm.$emit('scroll-on-table')
      }
    }
  }, _vm._l((_vm.courses), function(course, index) {
    return _c('tr', {
      key: index,
      staticClass: "row no-margin"
    }, [_c('td', {
      staticClass: "col-xs-1"
    }, [_c('pl-checkbox', {
      staticClass: "col-xs-1",
      on: {
        "change": function($event) {
          return _vm.handleSelectCourse($event, index)
        }
      },
      model: {
        value: (_vm.selectedCourses[index]),
        callback: function($$v) {
          _vm.$set(_vm.selectedCourses, index, $$v)
        },
        expression: "selectedCourses[index]"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "col-xs-3"
    }, [_vm._v("\n              " + _vm._s(course.title) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2"
    }, [(course.teacher_email) ? _c('div', {
      staticClass: "truncate-text",
      attrs: {
        "title": course.teacher_email
      }
    }, [_vm._v("\n                " + _vm._s(course.teacher_email) + "\n              ")]) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2"
    }, [(
      course.co_teachers_emails &&
      course.co_teachers_emails.length
    ) ? _c('div', _vm._l((course.co_teachers_emails), function(co_teacher, index) {
      return _c('div', {
        key: index,
        staticClass: "truncate-text",
        attrs: {
          "title": co_teacher
        }
      }, [_vm._v("\n                  " + _vm._s(co_teacher) + "\n                ")])
    }), 0) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1"
    }, [(course.subjects && course.subjects.length) ? _c('div', _vm._l((course.subjects), function(subject, index) {
      return _c('div', {
        key: index,
        staticClass: "truncate-text",
        attrs: {
          "title": subject
        }
      }, [_vm._v("\n                  " + _vm._s(subject) + "\n                ")])
    }), 0) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1 truncate-text",
      attrs: {
        "title": course.school_site
      }
    }, [_vm._v("\n              " + _vm._s(course.school_site) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1"
    }, [(course.grades && course.grades.length) ? _c('div', _vm._l((course.grades), function(grade, index) {
      return _c('div', {
        key: index,
        staticClass: "truncate-text",
        attrs: {
          "title": grade
        }
      }, [_vm._v("\n                  " + _vm._s(grade) + "\n                ")])
    }), 0) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1 center-xs"
    }, [_vm._v("\n              " + _vm._s(course.students_count) + "\n            ")])])
  }), 0)]) : _c('div', {
    staticClass: "row middle-xs center-xs no-courses-text ph5"
  }, [_vm._v("\n        Parlay has not received any course or user information from this\n        integration yet. If you recently enabled the integration, it can take\n        up to 24 hours for the data to propagate.\n      ")])], 1) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "flex my-8 center items-center"
  }, [(_vm.loading) ? _c('pl-spinner', {
    staticClass: "x2",
    staticStyle: {
      "margin": "auto"
    }
  }) : _c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold",
    attrs: {
      "disabled": (_vm.courses && !_vm.courses.length) || !_vm.selected_courses.length
    },
    on: {
      "click": _vm.importCourses
    }
  }, [_vm._v("\n      Import Courses to Parlay\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-ad74660c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/integrations/integrationsCoursesModal.vue
// module id = 2115
// module chunks = 61